import { Container } from "./styles";

const Btn = ({ ...rest }) => <Container {...rest} />;

export default Btn;
